import { countConversationsCreatedUniqueCustomer } from '../queries/countConversationsCreatedUniqueCustomer'

export const totalCustomersGauge = {
  description:
    'Total amount of customers that sent in a conversations (one customer may have multiple conversations) including spam and deleted conversations.',
  queries: [countConversationsCreatedUniqueCustomer],
  title: 'Customers',
}
